<template>
    <div class="columns is-centered is-multiline m-t-30">
        <div class="column is-full has-text-centered">
            <a href="/"><img :src="logo" alt=""> </a>
            <p class="heading ">
                Powered by 
                <span style="vertical-align:middle;">
                    <img width="95px" src="https://traction-prod.ams3.digitaloceanspaces.com/static/basics/logo.png" alt="">
                </span>
            </p>
        </div>
        <div class="column is-full has-text-centered">
            <p>
                <a class="m-r-5" style="color:#000" href="/">Inicio</a>
                <span class="m-r-5">|</span>
                <a v-if="blogBool && blogPowerUp == 'True'" class="m-r-5" style="color:#000" :href="blogUrl">Blog</a>
                <span class="m-r-5" v-if="blogBool && blogPowerUp == 'True'">|</span>
                <a class="m-r-5" style="color:#000" :href="contactUrl">Contacto</a>
                <span class="m-r-5" v-if="faqsBool">|</span>
                <a v-if="faqsBool" style="color:#000" :href="faqsUrl">Preguntas frecuentes</a>
                <span v-if="b2bBool"></span>
                <a
                :href="pedidosUrl"
                rounded
                v-if="b2bBool && loggedUser"
                class="button is-custom"
                >
                Hacer Pedido
                </a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        logo:{
            type:String,
            default:""
        },
        faqsBool:{
            type:Boolean,
            default:false
        },
        faqsUrl:{
            type:String,
            default:""
        },
        blogBool:{
            type:Boolean,
            default:false
        },
        blogUrl:{
            type:String,
            default:""
        },
        contactUrl:{
            type:String,
            default:""
        },
        blogPowerUp:{
            type:String,
            default:""
        },
        b2bBool:{
            type:Boolean,
            default:false
        },
        pedidosUrl:{
            type:String,
            default:""
        }
    }
}
</script>

<style lang="scss" scoped>

.is-custom{
    background: var(--primary);
    color: var(--text-color)
}

</style>